import React from 'react';
import {Button} from 'reactstrap';
import classnames from 'classnames';

class LoaderButton extends React.Component {

  render() {
    const {className, loading, children, outline, ...otherProps} = this.props;
    return (
      <Button
        className={`btn-multiple-state  ${className}  ${classnames(
          {
            'show-spinner': loading,
          }
        )}`}
        outline={typeof outline !== "undefined" ? outline && !loading : outline}
        {...otherProps}
      >
        <span className="spinner d-inline-block">
          <span className="bounce1"/>
          <span className="bounce2"/>
          <span className="bounce3"/>
        </span>
        <span className="label">{children}</span>
      </Button>
    );
  }
}

export default LoaderButton;
